/* Cabezas de ganado vistas de frente. Los puntos (ojos, narinas) son trazos de longitud 0 con remate redondo. */

export function VacaGlyph() {
  return (
    <>
      <path d="M8.2 6.2Q12 5 15.8 6.2C16.6 8.4 16.6 11 15.8 13.2C16.8 14 17.2 15.4 17.2 16.8C17.2 19.2 15.2 20.8 12 20.8C8.8 20.8 6.8 19.2 6.8 16.8C6.8 15.4 7.2 14 8.2 13.2C7.4 11 7.4 8.4 8.2 6.2Z" />
      <path d="M8 7.6L4.2 7C3.9 9 5 10.1 8 10" />
      <path d="M16 7.6L19.8 7C20.1 9 19 10.1 16 10" />
      <path d="M9 5.5C7.6 5 6.2 4 5.8 2.4" />
      <path d="M15 5.5C16.4 5 17.8 4 18.2 2.4" />
      <path d="M10.2 10.4h.01M13.8 10.4h.01M10.2 17.4h.01M13.8 17.4h.01" />
    </>
  );
}

export function BufaloGlyph() {
  return (
    <>
      <path d="M8.6 6.6Q12 5.4 15.4 6.6C16 9.2 15.4 12.5 16 15C16.4 16.6 16.2 18.4 15.2 19.6C14.4 20.6 13.2 21 12 21C10.8 21 9.6 20.6 8.8 19.6C7.8 18.4 7.6 16.6 8 15C8.6 12.5 8 9.2 8.6 6.6Z" />
      <path d="M8.5 8.4C4.6 9.6 2.4 7.4 2.4 2.8" />
      <path d="M15.5 8.4C19.4 9.6 21.6 7.4 21.6 2.8" />
      <path d="M10.4 11h.01M13.6 11h.01M10.9 17.4h.01M13.1 17.4h.01" />
    </>
  );
}

export function CerdoGlyph() {
  return (
    <>
      <path d="M5.5 8L4.7 3.9L9.5 5.4" />
      <path d="M18.5 8L19.3 3.9L14.5 5.4" />
      <circle cx="12" cy="13" r="8.2" />
      <ellipse cx="12" cy="15.4" rx="3.6" ry="2.7" />
      <path d="M10.6 15.4h.01M13.4 15.4h.01M8.6 10.8h.01M15.4 10.8h.01" />
    </>
  );
}
